import { render, staticRenderFns } from "./ExpertaChatMessage.vue?vue&type=template&id=596b6f82&scoped=true"
import script from "./ExpertaChatMessage.vue?vue&type=script&lang=js"
export * from "./ExpertaChatMessage.vue?vue&type=script&lang=js"
import style0 from "./ExpertaChatMessage.vue?vue&type=style&index=0&id=596b6f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b6f82",
  null
  
)

export default component.exports